export default __webpack_public_path__ + "static/media/butcher9.779055eb.png";